function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function TVAddon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.995 3a1.9 1.9 0 011.9 1.9v8.723h-.012a6.006 6.006 0 01-7.613 6.76.992.992 0 01-.653.241h-5.34a1 1 0 110-2h1.67v-1.341H2.9a1.901 1.901 0 01-1.9-1.9V4.9A1.9 1.9 0 012.9 3h18.096zm-4.028 7.627c-2.205 0-4 1.793-4 4 0 2.205 1.795 4 4 4 2.206 0 4-1.794 4-4 0-2.207-1.794-4-4-4zm0 1a1 1 0 011 1v.999h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1zM20.895 5H3v10.282h8.003a6.006 6.006 0 015.964-6.657c1.5 0 2.874.554 3.927 1.467V5.001z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoTVAddon = /*#__PURE__*/React.memo(TVAddon);
export default MemoTVAddon;